import { connect } from 'react-redux'
import get from 'lodash/get'

import getDates from './../services/date.service'
import {
  handleChangeStoreItemsIntellegence as onHandleChangeStore
} from '../../actions/itemsIntellegenceActions'

let momentTimeValue = new Date()
momentTimeValue.setSeconds(0)
momentTimeValue.setMilliseconds(0)

const mapStateToProps = (state) => ({
  itemsIntelligenceDataState: state.itemsIntellegence.dataState,
  momentDate: get(state, ['itemsIntellegence', 'itemsIntellegence', 'momentDate'], new Date()),
  momentTime: get(state, ['itemsIntellegence', 'itemsIntellegence', 'momentTime'], momentTimeValue),
  rangeStartDate: get(state, ['itemsIntellegence', 'itemsIntellegence', 'rangeStartDate'], getDates.getNullTimeDate(new Date())),
  rangeEndDate: get(state, ['itemsIntellegence', 'itemsIntellegence', 'rangeEndDate'], getDates.getNullTimeDate(new Date())),
  rangeStartTime: get(state, ['itemsIntellegence', 'itemsIntellegence', 'rangeStartTime'], getDates.getNullTimeDate(new Date())),
  rangeEndTime: get(state, ['itemsIntellegence', 'itemsIntellegence', 'rangeEndTime'], getDates.getEndDayTimeDate(new Date())),
  timeRange: get(state, ['itemsIntellegence', 'itemsIntellegence', 'timeRange']),
});

const mapDispatchToProps = {
  onHandleChangeStore
}

const withItemsIntellegence = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withItemsIntellegence }